import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import { Swatch } from '~js/components/swatch';

export class GridSwatch extends HTMLElement {
  constructor() {
    super();

    this.handle = this.getAttribute(a.attributes$E.handle);
    this.label = this.getAttribute(a.attributes$E.label).trim().toLowerCase();

    fetchProduct(this.handle).then((product) => {
      this.product = product;
      this.colorOption = product.options.find((element) => {
        return element.name.toLowerCase() === this.label || null;
      });

      if (this.colorOption) {
        this.swatches = this.colorOption.values;
        this.init();
      }
    });
  }

  init() {
    this.swatchElements = this.querySelectorAll(s.selectors$X.swatch);

    this.swatchElements.forEach((el) => {
      new Swatch(el);
    });

    this.handleShowMore();
  }

  handleShowMore() {
    this.initialHeight = this.offsetHeight;
    this.expandedHeight = this.initialHeight;
    const section = this.closest(s.selectors$X.sectionType);
    const moreLink = this.querySelector(s.selectors$X.swatchesMore);

    if (!moreLink) return;

    moreLink?.addEventListener('click', () => {
      this.classList.add(c.classes$N.isVisible);
    });

    section?.addEventListener('touchstart', (e) => {
      if (!this.contains(e.target)) {
        this.classList.remove(c.classes$N.isVisible);
        this.dispatchEvent(new Event('mouseleave', { bubbles: true }));
      }
    });

    this.addEventListener('mouseenter', () => {
      const onAnimationStart = (event) => {
        this.expandedHeight = this.offsetHeight;
        const slider = event.target.closest(s.selectors$X.slider);
        const heightDiffers = this.expandedHeight > this.initialHeight;

        if (heightDiffers && slider) {
          requestAnimationFrame(() =>
            slider.dispatchEvent(new CustomEvent('theme:slider:resize', { bubbles: false }))
          );
        }

        this.removeEventListener('animationstart', onAnimationStart);
      };

      this.addEventListener('animationstart', onAnimationStart);
    });

    this.addEventListener('mouseleave', () => {
      const onAnimationStart = (event) => {
        const slider = event.target.closest(s.selectors$X.slider);
        const heightDiffers = this.expandedHeight > this.initialHeight;

        if (heightDiffers && slider) {
          requestAnimationFrame(() =>
            slider.dispatchEvent(new CustomEvent('theme:slider:resize', { bubbles: false }))
          );
        }

        this.removeEventListener('animationstart', onAnimationStart);
      };

      this.addEventListener('animationstart', onAnimationStart);
    });
  }
}

function fetchProduct(handle) {
  const requestRoute = `${theme.routes.root}products/${handle}.js`;

  return window
    .fetch(requestRoute)
    .then((response) => {
      return response.json();
    })
    .catch((e) => {
      console.error(e);
    });
}